export enum RoleEnum {
  Supervisor = '1',
  CS = '2',
  CX = '3',
}

export function extractRoleEnum(role: string): RoleEnum | undefined {
  switch (role) {
    case 'Supervisor':
      return RoleEnum.Supervisor;
    case 'CS':
      return RoleEnum.CS;
    case 'CX':
      return RoleEnum.CX;
    default:
      return undefined;
  }
}

export function extractRoleString(role: string) {
  switch (role.toString()) {
    case '0': 
      return 'Superadmin';
    case '1': 
      return 'Supervisor';
    case '2':
      return 'CS';
    case '3':
      return 'CX';
    default:
      return undefined;
  }
}
